import types from "../types";
import state from "../defaultState";
import { fromJS } from "immutable";

const initialState = state.sitePosts;
export default function app(state = initialState, action) {
  switch (action.type) {
    case types.SET_GET_WRITINGS_DATA:
      return state.setIn(["data"], fromJS(action.payload));
    case types.SET_GET_WRITINGS_ERROR:
      return state.setIn(
        ["error"],
        fromJS(
          action.payload.response
            ? action.payload.response.error
            : action.payload.message
        )
      );
    default:
      return state;
  }
}
